import { makeAutoObservable } from 'mobx';
import fetchService from '../servises/fetch.service';
import { registerAccountStateReset } from '../servises/account-state.service';

class MongoDbMetricsStore {
    constructor() {
        makeAutoObservable(this);
    }

    mongoDbMetrics = [];
    requestSequence = 0;

    async getMongoMetrics(uptimeId) {
        const requestSequence = ++this.requestSequence;
        const response = await fetchService.authenticatedGet(
            `/mongo/${ uptimeId }`);
        const responseData = response.data.data_o;
        const data = responseData === null ? [] : responseData;
        if (requestSequence === this.requestSequence && Array.isArray(data)) {
            this.mongoDbMetrics = [...data].reverse();
        }
    }

    clear() {
        this.requestSequence += 1;
        this.mongoDbMetrics = [];
    }
}

const mongoDbMetricsStore = new MongoDbMetricsStore();
registerAccountStateReset(() => mongoDbMetricsStore.clear());

export default mongoDbMetricsStore;
